export default "__VITE_ASSET__DfjF2lde__"